export interface IconProps {
  size?: number;
  className?: string;
}

export const ChevronDownIcon = ({ size = 20, className = '' }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      className={className}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M19 9l-7 7-7-7' />
    </svg>
  );
};
